/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-10-19 10:20:44
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-10-10 11:19:14
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/hooks/useInitData.ts
 * @Description: 报名页数据获取
 */
import { useEffect, useMemo, useState, useContext } from 'react';
import { getHostDetailById, HostDetailRes } from '@model/host-account';
import ActivitiesRegisterQueryUserSchedule, {
  ActivitiesRegisterQueryUserScheduleRes,
} from '@quickService/ActivitiesRegisterQueryUserSchedule';
import ActivitiesPublicRegistrationPage, {
  Data as RegistrationData,
  ActivityBasicInfo,
} from '@quickService/ActivitiesPublicRegistrationPage';
import PublicRegistrationQueryEventSchedulers, {
  SchedulerDataList,
  Data as ScheduleData,
} from '@quickService/PublicRegistrationQueryEventSchedulers';
import { TicketType } from '../controller/getServerProps';
import { AppContext } from '@utils/browser/app-context';
import dayjs from 'dayjs';
import dataReport from '@utils/data-report';
import { ScheduleStatus } from '../components/scheduleBtn/index';
import PublicCouponQueryPublicList from '@quickService/PublicCouponQueryPublicList';
import buyerCoupon from '@model/buyer-coupon';
import { useRouter } from 'next/router';
import { getCookie } from '@utils/browser/get-cookie';

// const getTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
const transforActivtyTime = (activityInfo: any) => {
  const startTime = dayjs((activityInfo?.start_time || 0) * 1000);
  const endTime = dayjs((activityInfo?.end_time || 0) * 1000);
  let endTimeFmt = 'MM月DD日 HH:mm';
  if (endTime.date() === startTime.date()) {
    endTimeFmt = 'HH:mm';
  }
  // const isSameTz = getTz() === activityInfo?.time_zone;
  // eslint-disable-next-line
  // const curTz = !isSameTz ? new Date().toTimeString().match(/GMT\+(\d+)/)![0] : '';
  return `${startTime.format('MM月DD日 HH:mm')} - ${endTime.format(endTimeFmt)}`;
};

// 距离开始15分钟时候，15*60=900s
const duration = 900;
// 查询我的日程列表
export const useMyScheduleList = (eventId: string) => {
  const { userData, setUserData } = useContext(AppContext);
  const [myScheduleList, setMyScheduleList] = useState<any>();

  useEffect(() => {
    userData?.userid &&
      ActivitiesRegisterQueryUserSchedule({
        event_id: eventId,
      })
        .then((res: ActivitiesRegisterQueryUserScheduleRes) => {
          const { code, data } = res;
          if (code === 0) {
            const { own_schedules: ownSchedules, approving_schedules: approvingSchedules } = data;

            // 时间处理，将即将开始的处理一下
            const time = Date.now() / 1000;
            // @ts-ignore
            const allSchedules = ownSchedules?.concat(approvingSchedules || []).map((item) => {
              if (item.schedule_status === ScheduleStatus.NO_START) {
                // 未开始的话，就需要做一下判断
                const { begin_time: bTime } = item;
                if (time + duration >= (bTime || 0)) {
                  // @ts-ignore
                  item.needShowStart = true;
                }
              }

              return item;
            });

            setMyScheduleList(allSchedules);
          }

          // @ts-ignore
          if (userData.goAndUpdateTicket) {
            // 跳转到我的日程那里去
            const el = document.querySelector('#my-sidecard-ticket');

            el?.scrollIntoView({
              behavior: 'smooth',
            });
          }
        })
        .catch(() => {
          // 处理后台接口请求报错的情况，接口报错时默认置为空，防止报名按钮不展示
          setMyScheduleList([]);
        });

    // @ts-ignore
    if (userData?.updateCoupon) {
      // 更新下优惠券列表
      PublicCouponQueryPublicList({
        event_id: eventId,
      }).then((res) => {
        if (res.code === 0) {
          const nCoupons = res.data?.coupons;

          if (nCoupons) {
            const resetCoupons = buyerCoupon.transformCoupons(nCoupons);
            buyerCoupon.setCoupons(resetCoupons);
          }
        }
      });
    }
    // 判断为未登录
    if (!getCookie('app_uid')) {
      setMyScheduleList([]);
    }
  }, [userData]);

  useEffect(() => {
    // @ts-ignore
    if (userData.goToTickets) {
      // 跳转到我的日程那里去
      const el = document.querySelector('#my-sidecard-ticket');
      const el2 = document.querySelector('#mobile-my-schedule');

      el?.scrollIntoView({
        behavior: 'smooth',
      });
      el2?.scrollIntoView({
        behavior: 'smooth',
      });
      setTimeout(() => {
        setUserData({
          ...userData,
          goToTickets: false,
        });
      }, 1600);
    }
  }, [userData]);

  return myScheduleList;
};

// 查询主办方信息
export const useHostData = (hostId: any) => {
  const [hostData, setHostData] = useState<HostDetailRes['data']>();
  useEffect(() => {
    getHostDetailById(hostId).then((data) => {
      setHostData(data);
    });
    // sessionStorage.setItem('curr:hostId', String(hostId));
  }, []);

  return hostData;
};

// 获取选中日程和时间
export const useScheduleList = (
  activityInfo: ActivityBasicInfo,
  scheduleData: SchedulerDataList = [],
  selectId?: any,
) => {
  const [curr, setCurr] = useState(0);
  // 显示的日程信息
  const { dates, datas }: any = useMemo(() => {
    if (activityInfo.ticket_type === TicketType.SINGLE) {
      // 场次票需要选择场次之后才显示
      return {
        dates: [],
        datas: scheduleData.filter((item) => item.scheduler_id === selectId),
      };
    }

    let dates: string[] = scheduleData
      .map((x) => {
        const [bTime, eTime] = [x.begin_time, x.end_time].map((x) => parseInt(String(x), 10));
        const hours = (eTime - bTime) / 3600;
        if (hours > 48) {
          const q = dayjs(bTime * 1000).add(1, 'day');
          return [bTime, q.unix(), eTime].map((x) => dayjs(x * 1000).format('MM月DD日'));
        }
        return [bTime, eTime].map((x) => dayjs(x * 1000).format('MM月DD日'));
      })
      // @ts-ignore
      .flat();
    dates = ['全部', ...new Set(dates)];
    const map = new Map<number, SchedulerDataList>([[0, scheduleData]]);
    scheduleData.forEach((e) => {
      const [bTime, eTime] = [e.begin_time, e.end_time];

      const [bDate, eDate] = [bTime, eTime]
        .map((x) => parseInt(String(x), 10))
        .map((x) => dayjs(x * 1000).format('MM月DD日'));
      let index = dates.indexOf(bDate);
      if (index > -1) {
        if (map.has(index)) {
          map.get(index)?.push(e);
        } else {
          map.set(index, [e]);
        }
      }
      index = dates.indexOf(eDate);
      if (index > -1) {
        if (map.has(index)) {
          const arr = map.get(index);
          if (arr?.findIndex((x) => x.scheduler_id === e.scheduler_id) === -1) {
            arr.push(e);
          }
        } else {
          map.set(index, [e]);
        }
      }
      const hours = (eTime - bTime) / 3600;
      if (hours > 48) {
        const midDate = dayjs(bTime * 1000)
          .add(1, 'day')
          .format('MM月DD日');
        index = dates.indexOf(midDate);
        if (index > -1) {
          if (map.has(index)) {
            const arr = map.get(index);
            if (arr?.findIndex((x) => x.scheduler_id === e.scheduler_id) === -1) {
              arr.push(e);
            }
          } else {
            map.set(index, [e]);
          }
        }
      }
    });
    return {
      dates: dates.map((e: string, index: number) => ({
        text: e,
        count: map.get(index)?.length,
      })),
      datas: map,
    };
  }, [selectId, scheduleData]);

  const showScheduleList: any = useMemo(() => {
    if (activityInfo.ticket_type === TicketType.PACKAGE) {
      return datas.get(curr);
    }
    return datas;
  }, [curr, selectId, datas]);

  const actTime = useMemo(() => {
    if (activityInfo.ticket_type === TicketType.PACKAGE) {
      return transforActivtyTime(activityInfo);
    }
    // 根据选中的时间来显示
    return transforActivtyTime({
      start_time: showScheduleList?.[0]?.begin_time,
      end_time: showScheduleList?.[0]?.end_time,
    });
  }, [showScheduleList]);

  return {
    showScheduleList,
    actTime,
    dates,
    setCurr,
    curr,
  };
};

// 一些基础信息如价格等
export const useInitData = (registrationData: RegistrationData) => {
  const { updateRegisterHostData } = useContext(AppContext);
  const [price] = useMemo(() => {
    let showPrice = '';
    const {
      min_price: minPrice,
      max_price: maxPrice,
      show_price: price,
    } = registrationData.activity_basic_info;

    if (registrationData.event_enroll_status === 0 || !price) {
      showPrice = '';
    } else if (maxPrice === 0) {
      showPrice = '免费';
    } else if (minPrice === maxPrice) {
      showPrice = `¥${(maxPrice / 100).toFixed(2)}`;
    } else {
      showPrice = `¥${(minPrice / 100).toFixed(2)} - ¥${(maxPrice / 100).toFixed(2)}`;
    }

    return [showPrice];
  }, []);

  // 初始化选中的场次id
  const selectScheduleId = useMemo(() => {
    if (registrationData.activity_basic_info.ticket_type === TicketType.PACKAGE) {
      return '';
    }

    // 需要找到待开始的最近的场次
    let i = 0;
    const scheduleList = registrationData.activity_basic_info.schedules;
    if (!scheduleList) {
      return '';
    }
    const len = scheduleList.length;
    const nTime = Date.now() / 1000;
    // 已经排序好了，最后的就是最晚结束的
    let selectId = scheduleList[len - 1].schedule_id;
    // 如果有待开始的，就取最前面待开始的就好了
    for (i; i < len; i++) {
      const item = scheduleList[i];
      const { start_time: startTime, schedule_id: scheduleId } = item;
      // @ts-ignore
      if (nTime < startTime) {
        selectId = scheduleId;
        break;
      }
    }

    return selectId;
  }, []);

  useEffect(() => {
    updateRegisterHostData({
      host_id: registrationData.activity_basic_info.host_id,
    });
  }, []);
  return [price, selectScheduleId];
};

export const useExposure = (exportKey: string, activityId: string, isCanvas: boolean) => {
  useEffect(() => {
    const startTime = Date.now();
    const caculateTime = () => {
      const duration = parseInt(((Date.now() - startTime) / 1000).toString(), 10);
      dataReport(exportKey, {
        usage_time: duration,
        activity_id: activityId,
        registration_page_style: +isCanvas,
      });
    };
    window.addEventListener('beforeunload', caculateTime);

    return () => {
      caculateTime();
      window.removeEventListener('beforeunload', caculateTime);
    };
  }, []);
};

export const loadImage = (src: string) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(true);
    };
    img.src = src;
    img.onerror = () => {
      reject();
    };
  });

/**
 * 页面加载完成之后再请求获取高清图
 * @param eventId 活动id
 */
export const resetInitDataForOriginImg = (
  eventid: string,
  registrationData: RegistrationData,
  scheduleData: ScheduleData,
) => {
  const [rData, setRData] = useState(registrationData);
  const [sData, setSData] = useState(scheduleData);
  const router = useRouter();
  useEffect(() => {
    const { temp, ispreview } = router?.query || {};
    const tempToken = temp ? (temp as string) : '';
    let source: 0 | 1 | 2 | undefined = 0;
    if (ispreview === '1' && !tempToken) source = 1;
    if (tempToken) source = 2;
    const getFullPageData = async () => {
      const pageData = await Promise.all([
        ActivitiesPublicRegistrationPage({
          event_id: eventid,
          cos_image_type: 'origin',
          source,
          temp_token: tempToken,
        }),
        PublicRegistrationQueryEventSchedulers({
          event_id: eventid,
          guest_image_type: 'mid',
          scheduler_pic_image_type: 'mid',
          source,
          temp_token: tempToken,
        }),
      ]);
      const nRdata = pageData?.[0]?.data || '';
      const nSdata = pageData?.[1].data || '';

      // 先把第一页的高清图片加载出来
      if (nRdata.activity_basic_info?.background_urls?.length > 0) {
        loadImage(nRdata.activity_basic_info?.background_urls[0]).then(
          () => {
            setRData(nRdata);
          },
          () => {
            setRData(nRdata);
          },
        );
      }

      nSdata && setSData(nSdata);
    };

    getFullPageData();
  }, []);

  return { rData, sData };
};

// 替换图片链接为webp链接
export const useIntroductionImageToWebP = (content = '') => {
  const introduction = useMemo(() => {
    // 图片增加webp后缀处理
    const imageRegex = /<img\s+src="([^"]+)"([\s\w0-9="\-_/.]+\/>)/gm;
    // 替换所有的链接并且加上webp的优化
    const modifiedText = content.replace(
      imageRegex,
      '<img src="$1&imageMogr2/format/webp/quality/90" onerror=this.src="$1" $2',
    );

    return modifiedText;
  }, [content]);

  return introduction;
};
